import { Icon } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export interface WorkingConditionVersionSectionProps {
  icon: React.ComponentProps<typeof Icon.Large>['icon']
  label: string
  items: WorkingConditionDisplayItemProps[]
  group_items?: boolean
}

export interface WorkingConditionDisplayItemProps {
  itemId?: string
  name: string
  value?: string //| number | boolean
  type: string
  // if the type is 'string' and the allowedValues is provided,
  // the item is considered a `categorical_data`type
  allowedValues?: string[]
  default?: string
}

export const useWorkConditionsItemsStructure = (): WorkingConditionVersionSectionProps[] => {
  return [
    {
      icon: 'clock',
      label: 'work_time',
      group_items: true,
      items: [{ name: 'max_legal_yearly_hours', type: 'cents' }],
    },
    {
      icon: 'holidays-event-date',
      label: 'bank_holidays',
      group_items: false,
      items: [
        {
          name: 'bank_holiday_treatment',
          type: 'string',
          allowedValues: ['non_workable', 'workable'],
          default: 'non_workable',
        },
      ],
    },
  ]
}

type SectionKeySuffix = 'description' | 'title'

export const getI18nSectionKey = (name: string, suffix: SectionKeySuffix): string => {
  if (name === 'work_time') {
    switch (suffix) {
      case 'description':
        return i18n.t(
          `company_settings.general.employment_data.work_conditions.field_sections.work_time.description`
        )
      case 'title':
        return i18n.t(
          `company_settings.general.employment_data.work_conditions.field_sections.work_time.title`
        )
      default:
        return ''
    }
  } else if (name === 'bank_holidays') {
    switch (suffix) {
      case 'description':
        return i18n.t(
          `company_settings.general.employment_data.work_conditions.field_sections.bank_holidays.description`
        )
      case 'title':
        return i18n.t(
          `company_settings.general.employment_data.work_conditions.field_sections.bank_holidays.title`
        )
      default:
        return ''
    }
  }
  return ''
}
type ItemKeySuffix = 'label' | 'description'
export const getI18nItemFieldKey = (name: string, suffix: ItemKeySuffix): string => {
  if (name === 'max_legal_yearly_hours') {
    switch (suffix) {
      case 'label':
        return i18n.t(
          'company_settings.general.employment_data.work_conditions.field_items.max_legal_yearly_hours.label'
        )
      case 'description':
        return i18n.t(
          'company_settings.general.employment_data.work_conditions.field_items.max_legal_yearly_hours.description'
        )
      default:
        return ''
    }
  } else if (name === 'bank_holiday_treatment.non_workable') {
    switch (suffix) {
      case 'label':
        return i18n.t(
          'company_settings.general.employment_data.work_conditions.field_items.bank_holiday_treatment.values.non_workable.label'
        )
      case 'description':
        return i18n.t(
          'company_settings.general.employment_data.work_conditions.field_items.bank_holiday_treatment.values.non_workable.description'
        )
      default:
        return ''
    }
  } else if (name === 'bank_holiday_treatment.workable') {
    switch (suffix) {
      case 'label':
        return i18n.t(
          'company_settings.general.employment_data.work_conditions.field_items.bank_holiday_treatment.values.workable.label'
        )
      case 'description':
        return i18n.t(
          'company_settings.general.employment_data.work_conditions.field_items.bank_holiday_treatment.values.workable.description'
        )
      default:
        return ''
    }
  }
  return ''
}
